import { api } from "../configs/apiConfig";

export const getReplies = async (parentMessageId) => {
    if (!parentMessageId) {
        throw new Error('Parent message ID is required to get replies');
    }
    const response = await api.get(`/Message/${parentMessageId}/replies`);
    return response.data;
};

const messageService = {
    getAll: async () => {
        const response = await api.get("/Message");
        return response.data;
    },

    getById: async (id) => {
        const response = await api.get(`/Message/${id}`);
        return response.data;
    },

    create: async (messageData, files = []) => {
        const formData = new FormData();
        
        // Add message data
        formData.append('subject', messageData.subject);
        formData.append('content', messageData.content);
        formData.append('senderId', messageData.senderId);
        
        if (messageData.categoryId) {
            formData.append('categoryId', messageData.categoryId);
        }
        
        if (messageData.recipientIds && messageData.recipientIds.length > 0) {
            messageData.recipientIds.forEach(id => {
                formData.append('recipientIds', id);
            });
        }
        
        if (messageData.ccRecipientIds && messageData.ccRecipientIds.length > 0) {
            messageData.ccRecipientIds.forEach(id => {
                formData.append('ccRecipientIds', id);
            });
        }

        if (messageData.parentMessageId) {
            formData.append('parentMessageId', messageData.parentMessageId);
        }

        // Add files if any
        if (files && files.length > 0) {
            files.forEach(file => {
                formData.append('files', file);
            });
        }

        const response = await api.post("/Message", formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    },

    update: async (id, formData) => {
        const response = await api.put(`/Message/${id}`, formData);
        return response.data;
    },

    delete: async (id) => {
        await api.delete(`/Message/${id}`);
    },

    reply: async (id, formData) => {
        const response = await api.post(`/Message/${id}/reply`, formData);
        return response.data;
    },

    getInbox: async (userId) => {
        if (!userId) {
            throw new Error('User ID is required to get inbox messages');
        }
        const response = await api.get(`/Message/inbox/${userId}`);
        return response.data;
    },

    getSentItems: async (userId) => {
        if (!userId) {
            throw new Error('User ID is required to get sent messages');
        }
        const response = await api.get(`/Message/sent/${userId}`);
        return response.data;
    },

    markAsRead: async (id) => {
        await api.post(`/Message/${id}/read`);
    },

    // Attachment related methods
    deleteAttachment: async (attachmentId) => {
        await api.delete(`/Message/attachments/${attachmentId}`);
    },

    downloadAttachment: async (attachmentId) => {
        const response = await api.get(`/Message/attachments/${attachmentId}/download`, {
            responseType: 'blob'
        });
        return response.data;
    },

    getReplies,

    getUnreadCount: async (userId) => {
        if (!userId) {
            throw new Error('User ID is required to get unread message count');
        }
        const messages = await messageService.getInbox(userId);
        return messages.filter(m => !m.isRead).length;
    },

    createAnonymous: async (messageData, files = []) => {
        const formData = new FormData();
        
        // Add message data
        formData.append('subject', messageData.subject || 'Anonymous Message');
        formData.append('content', messageData.content);
        formData.append('captchaKey', messageData.captchaKey);
        formData.append('captchaValue', messageData.captchaValue);
        
        // Add files if any
        if (files && files.length > 0) {
            files.forEach(file => {
                formData.append('files', file);
            });
        }

        const response = await api.post("/Message/anonymous", formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    }
};

export default messageService; 